import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const AuthContext = createContext({});
const AuthContextProvider = ({ children, defaultValue, }) => (jsx(AuthContext.Provider, Object.assign({ value: defaultValue }, { children: children })));
const useAuthConfigStore = () => useContext(AuthContext);

export { AuthContextProvider, useAuthConfigStore };
